import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import * as moment from 'moment';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { ExportgridComponent } from '../../grid/exportgrid/exportgrid.component';
import { SalesquickviewComponent } from '../salesquickview/salesquickview.component';

@Component({
  selector: 'app-trailbalancereport',
  templateUrl: './trailbalancereport.component.html',
  styleUrls: ['./trailbalancereport.component.css']
})
export class TrailbalancereportComponent implements OnInit, OnDestroy {
 

    @ViewChild('filterbar', { static: false }) filterbar;
  
    isadd: boolean = false;
    isedit: boolean = false;
    isdelete: boolean = false;
    isview: boolean = false;
    isprint: boolean = false;
    isexport: boolean = false;
    isfilter: boolean = false;
  
  
    isloading: boolean = false;
    isprivilage: boolean = false;
    showProgress: boolean = false;
  
  
    formname: string = "BillSummaryReport";
  
  
    gridformtype: string = "";
  
    checkemp: string = "";
    companycheckColl: any = [];
    filterstatus: string = "ALL";
    salesreportColl: any = [];
    stationColl: any = [];
    groupColl: any = [];
    subgroupColl: any = [];
    productColl: any = [];
    reasonColl: any = [];
  
  
    fromdate: any = new Date();
    todate: any = new Date();
    filterdinetypeid: number = null;
    filtergroupid: number = null;
    filtersubgroupid: number = null;
    filterstationid: number = null;
    filterproductid: number = null;
    filterreasonid: number = null;
  
    rtntype: any = "";
    filterby: any = "";
  
    trailbalanceColl: any = [];
    searchtxt: any = "";
  
    columnDefs = [
      { headerName: 'Ledger', field: 'accountname' },
      { headerName: 'Trx No', field: 'trxno' },
      { headerName: 'Trx Date', field: 'trxdate', type: 'date' },
      { headerName: 'Document Type', field: 'doctype' },
      { headerName: 'Description', field: 'descr' },
      { headerName: 'Cost Center', field: 'costcentername' },
      { headerName: 'Sub Ledger', field: 'subledgername' },
      { headerName: 'Debit Amount', field: 'dramt', type: 'decimal' },
      { headerName: 'Credit Amount', field: 'cramt', type: 'decimal' },
    ]
  
    gridOptions = {
      enableactioncol: false,
      columnDefs: this.columnDefs,
    };
  
    dateCustomClasses: DatepickerDateCustomClasses[];
  
    _routerLoginSub = Subscription.EMPTY;
  
    constructor(private appService: DhukanDataService, public router: Router, private productFindService: NgbModal, private datePipe: DatePipe, private route: ActivatedRoute,
      private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService, public loginService: LoginDataService) {
      this.fnServiceChanges();
  
  
    }
  
    //Company Check
    fnServiceChanges() {
      this.loginService.serviceloginChange.subscribe((value) => {
        if (this.loginService.fnCheckCompany()) {
          if (this.loginService.fnCheckUser()) {
            this.fnCheckPrivilage();
            if (this.isview) {
              this.isloading = true;
              this.fnOnInitForm();
            }
            else {
              this.fnUserFailedForm();
            }
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
      });
  
  
      this._routerLoginSub = this.route.queryParams.subscribe(params => {
  
        if (params.fromdate !== undefined) {
          this.fromdate = this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
        }
  
        if (params.todate !== undefined) {
          this.todate = this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
        }
  
        if (params.rtntype !== undefined) {
          this.rtntype = params.rtntype
        }
        if (params.filterby !== undefined) {
          this.filterby = params.filterby
        }
  
  
  
  
      })
  
    }
  
  
    ngOnInit() {
      try {
        if (this.loginService.fnCheckCompany()) {
          if (this.loginService.fnCheckUser()) {
            this.fnCheckPrivilage();
            if (this.isview) {
              this.isloading = true;
              this.fnOnInitForm();
            }
            else {
              this.fnUserFailedForm();
            }
          }
          else {
            this.loginService.fnGetUserRoleList();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
      } catch (ex) {
        this.fnShowErrorMsg(ex);
      }
    }
    fnOnInitForm() {
      this.fngetBillSummaryReport();
  
    }
  
  
    fnCheckPrivilage() {
  
      this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
      this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
      this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
      this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
      this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
      this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');
  
  
    }
  
    fnUserFailedForm() {
      this.isprivilage = true;
    }
  
  
  
    ngOnDestroy(): void {
      if (this._routerLoginSub !== undefined) {
        this._routerLoginSub.unsubscribe();
      }
    }
  
  
  
  
    //Get
    fngetBillSummaryReport() {
      try {
        this.fnShowProgress()
  
        var data = {
          'fromdate': this.fnFormatDatetime(this.fromdate),
          'todate': this.fnFormatDatetime(this.todate),
          'companyid': this.loginService.fnGetCompanyId(),
        }
  
        this.appService.getTrailBalanceReport(data)
          .subscribe(
            (res) => {
              this.fnHideProgress()
  
              if (res.json().status === 200) {
                this.trailbalanceColl = res.json().result;
  
                this.fnCurrentRouteChange();
  
              } else if (res.json().status === 400) {
                this.toastr.error("Error", res.json().err_field)
              }
            },
            (err) => {
              this.fnHideProgress()
              this.toastr.error('Error', err);
            })
      } catch (ex) {
        this.fnHideProgress()
        this.fnShowErrorMsg(ex)
      }
    }
  
    fnCurrentRouteChange() {
      var queryParams = {};
  
      if (this.fromdate != '') {
        queryParams['fromdate'] = this.fnFormatDatetime(this.fromdate);
      }
      if (this.todate != '') {
        queryParams['todate'] = this.fnFormatDatetime(this.todate);
      }
  
      if (this.rtntype != '') {
        queryParams['rtntype'] = this.rtntype;
      }
  
      if (this.filterby != '') {
        queryParams['filterby'] = this.filterby;
      }
  
  
      this.router.navigate(
        [],
        {
          relativeTo: this.route,
          queryParams: queryParams,
  
        });
    }
  
  
    fnViewQuickSales(event) {
      const modalRef = this.productFindService.open(SalesquickviewComponent, { size: <any>'xxl', backdrop: 'static' });
      modalRef.componentInstance.salesid = event.salesid;
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
  
      });
    }
  
  
  
    fnSetTable() {
  
    }
  
    private fnFocusTableRow(index, status) {
      if (index > -1) {
        if (status === 'IN') {
          this.trailbalanceColl[index].hoverfocus = "IN"
        }
        else {
          this.trailbalanceColl[index].hoverfocus = ""
        }
      }
    }
  
    fnTabHeaderClick(type) {
      this.searchtxt = "";
      this.gridformtype = type;
    }
  
    fnCloseForm() {
      try {
  
  
        if (this.rtntype === 'Dashboard') {
  
          let navigationExtras: NavigationExtras = {
            queryParams: {
              'filterby': this.filterby,
            }
          }
  
          this.router.navigate(['/'], navigationExtras);
  
        }
        else {
          this.router.navigate(['/Report']);
        }
  
      } catch (ex) {
        this.fnShowErrorMsg(ex);
      }
    }
    fnActionExportClick() {
      const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
      modalRef.componentInstance.doctype = this.formname;
      modalRef.componentInstance.columnDefs = this.columnDefs;
      modalRef.componentInstance.contentColl = this.trailbalanceColl;
      modalRef.componentInstance.fnSetTable();
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
  
      });
    }
  
  
    fnMomentDateTimeFormatter(params) {
      if (params.value) {
        return moment(params.value).format('DD-MM-YYYY hh:mm a');//  
      }
      else {
        return '';
      }
  
    }
    fnFormatDatetime(dt) {
      if (dt) {
        if (dt === "") {
          return null
        }
        else {
          return this.datePipe.transform(dt, "yyyy-MM-dd")
        }
  
      } else {
        return null
      }
  
    }
    fnConvertDatetime(dt) {
      if (dt) {
        if (dt === "") {
          return null
        }
        else {
          var dateParts = dt.split("-");
          var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
          sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
          return sdate;
        }
  
      } else {
        return null
      }
  
    }
    // private fnExport() {
  
    //   const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'l', backdrop: 'static' });
    //   modalRef.componentInstance.doctype = this.formname;
    //   modalRef.componentInstance.columnDefs = this.columnDefs;
    //   modalRef.componentInstance.contentColl = this.activitylogColl;
    //   modalRef.componentInstance.fnSetTable();
    //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
  
    //   });
  
    // }
    fnInsertActivityLog(action, refno, desc) {
      try {
        var data = {
          logtype: action,
          logat: this.formname,
          refnum: refno,
          logdescr: desc,
          logby: this.loginService.fnGetModUserId(),
        }
  
  
        this.appService.fnInsertActivity(data).subscribe(
          (res) => {
          },
          (err) => {
  
          });
  
      } catch {
  
      }
    }
  
    private fnShowProgress() {
      this.showProgress = true;
    }
    private fnHideProgress() {
      this.showProgress = false;
    }
  
  
    private fnShowErrorMsg(ex) {
      this.toastr.warning('Internal Error', ex);
    }
  
  
  
  
  
  
  
  
  
  

}
